export default __webpack_public_path__ + "static/media/scheduler-sidebar-icon.14702441.svg";